interface ClosemodalProps {
  className?: string;
  setClosePopUp?: Function;
  otherFunction?: Function;
}

const Closemodal = (props: ClosemodalProps) => {
  return (
    <svg
      className={`${props.className ? props.className : ""} cursor-pointer`}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => {
        if (props.setClosePopUp) {
          props.setClosePopUp!(false);
        }
        if (props.otherFunction) {
          props.otherFunction(false);
        }
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7081 1.70612C16.0981 1.31505 16.0972 0.681883 15.7061 0.291905C15.315 -0.0980728 14.6819 -0.0971872 14.2919 0.293883L8 6.60341L1.7081 0.293883C1.31812 -0.0971872 0.684953 -0.0980728 0.293883 0.291905C-0.0971872 0.681883 -0.0980728 1.31505 0.291905 1.70612L6.58776 8.01961L0.291905 14.3331C-0.0980728 14.7242 -0.0971872 15.3573 0.293883 15.7473C0.684953 16.1373 1.31812 16.1364 1.7081 15.7453L8 9.4358L14.2919 15.7453C14.6819 16.1364 15.315 16.1373 15.7061 15.7473C16.0972 15.3573 16.0981 14.7242 15.7081 14.3331L9.41224 8.01961L15.7081 1.70612Z"
      />
    </svg>
  );
};

export default Closemodal;
